function setFlaggedFlagIcon(resultId, state) {
    setFlagIcon(resultId, 'flagged', state);
}

async function toggleFlaggedFlag(resultId) {
    const flagDiv = $('.flagged-div[data-result-id="' + resultId + '"]').first();
    const state = !flagDiv.data('flagged');
    if (await sendFlagState(resultId, ApiResultFlagsEnum.isFlagged, state)) {
        setFlaggedFlagIcon(resultId, state);
        notifyFlagChange(resultId, ApiResultFlagsEnum.isFlagged, state);
    }
}

async function toggleFlaggedFlagMultiple(resultIds) {
    const flagDiv = $('.flagged-div[data-result-id="' + resultIds[0] + '"]').first();
    const state = !flagDiv.data('flagged');
    if (await sendFlagStateMultiple(resultIds, ApiResultFlagsEnum.isFlagged, state)) {
        resultIds.forEach(function (resultId) {
            setFlaggedFlagIcon(resultId, state);
        });
        notifyFlagChangeMultiple(resultIds, ApiResultFlagsEnum.isFlagged, state);
    }
}

function setStrikethroughFlagIcon(resultId, state) {
    setFlagIcon(resultId, 'strike', state);
}

function setStrikethroughLineState(resultId, state) {
    $('.strike-div[data-result-id="' + resultId + '"]').each(function () {
        if (state) {
            $(this).parents('tr').addClass('strikeout');
        } else {
            $(this).parents('tr').removeClass('strikeout');
        }
    });
}

async function toggleStrikeOutFlag(resultId) {
    const flagDiv = $('.strike-div[data-result-id="' + resultId + '"]').first();
    const state = !flagDiv.data('strike');
    if (await sendFlagState(resultId, ApiResultFlagsEnum.isStruckOut, state)) {
        setStrikethroughFlagIcon(resultId, state);
        setStrikethroughLineState(resultId, state);
        notifyFlagChange(resultId, ApiResultFlagsEnum.isStruckOut, state);
    }
}

async function toggleStrikeOutFlagMultiple(resultIds) {
    const flagDiv = $('.strike-div[data-result-id="' + resultIds[0] + '"]').first();
    const state = !flagDiv.data('strike');
    if (await sendFlagStateMultiple(resultIds, ApiResultFlagsEnum.isStruckOut, state)) {
        resultIds.forEach(function (resultId) {
            setStrikethroughFlagIcon(resultId, state);
            setStrikethroughLineState(resultId, state);
        });
        notifyFlagChangeMultiple(resultIds, ApiResultFlagsEnum.isStruckOut, state);
    }
}

function setFlagIcon(resultId, flag, state) {
    $('.' + flag + '-div[data-result-id="' + resultId + '"]').each(function () {
        const flagDiv = $(this);
        const flagIcon = flagDiv.find('i');

        let oldClass = 'click_icon';
        let newClass = 'unclicked_icon';

        if (state) {
            oldClass = 'unclicked_icon';
            newClass = 'click_icon';
        }

        flagIcon.removeClass(oldClass);
        flagIcon.addClass(newClass);

        flagDiv.data(flag, state);
    });
}

function getFlagState(resultId, flag){
    const flagDiv = $(`.${flag}-div[data-result-id="${resultId}"]`).first();
    return flagDiv.data(flag);
}

function setFlagIconAll(flag, state) {
    $('.' + flag + '-div').each(function () {
        const flagDiv = $(this);
        const flagIcon = flagDiv.find('i');

        let oldClass = 'click_icon';
        let newClass = 'unclicked_icon';

        if (state) {
            oldClass = 'unclicked_icon';
            newClass = 'click_icon';
        }

        flagIcon.removeClass(oldClass);
        flagIcon.addClass(newClass);

        flagDiv.data(flag, state);
    });
}

function setInFinalChainFlagIcon(resultId, state) {
    const affectedResultIds = getAllResultIdsWithSameDocumentId(resultId);

    affectedResultIds.forEach(function (resultId) {
        setFlagIcon(resultId, 'chain', state);
    });
}

async function toggleInFinalChainFlag(resultId) {
    const flagDiv = $('.chain-div[data-result-id="' + resultId + '"]').first();
    const state = !flagDiv.data('chain');

    if (await sendFlagState(resultId, ApiResultFlagsEnum.isInFinalChain, state)) {
        setInFinalChainFlagIcon(resultId, state);
        const affectedResultIds = getAllResultIdsWithSameDocumentId(resultId);
        notifyFlagChangeMultiple(affectedResultIds, ApiResultFlagsEnum.isInFinalChain, state);
        await reloadFinalChain();
    }
}

async function toggleInFinalChainFlagMultiple(resultIds){
    const flagDiv = $('.chain-div[data-result-id="' + resultIds[0] + '"]').first();
    const state = !flagDiv.data('chain');
    if (await sendFlagStateMultiple(resultIds, ApiResultFlagsEnum.isInFinalChain, state)) {
        const allAffectedResultIds = [];
        resultIds.forEach(function (resultId) {
            setInFinalChainFlagIcon(resultId, state);
            const affectedResultIds = getAllResultIdsWithSameDocumentId(resultId);
            allAffectedResultIds.push(affectedResultIds);

        });
        notifyFlagChangeMultiple(allAffectedResultIds, ApiResultFlagsEnum.isFlagged, state);
        await reloadFinalChain();
    }
}

function getAllResultIdsWithSameDocumentId(resultId) {
    const documentId = $('.chain-div[data-result-id="' + resultId + '"]').data('documentId');
    return $('.chain-div[data-document-id="' + documentId + '"]').map(function (index, element) {
        return $(element).data('resultId');
    }).get();
}

function syncFlagStateForMatchingDocuments(resultId) {
    const flaggedState = getFlagState(resultId, 'flagged');
    const strikeState = getFlagState(resultId, 'strike');
    const chainState = getFlagState(resultId, 'chain');

    const affectedResultIds = getAllResultIdsWithSameDocumentId(resultId);

    for(const affectedResultId of affectedResultIds){
        setFlaggedFlagIcon(affectedResultId, flaggedState);
        setStrikethroughFlagIcon(affectedResultId, strikeState);
        setStrikethroughLineState(affectedResultId, strikeState);
        setInFinalChainFlagIcon(affectedResultId, chainState);
    }
}
